import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { SubscriptionsFilter } from "./SubscriptionsFilter";
import { SubscriptionsList } from "./SubscriptionsList";

// Компоновка раздела как у features/users: FilterProvider → Stack →
// карточка фильтров → список.
export const Subscriptions: FC = () => {
  return (
    <FilterProvider>
      <Stack spacing={1}>
        <SubscriptionsFilter />
        <SubscriptionsList />
      </Stack>
    </FilterProvider>
  );
};
